import type { Fbq } from './types'

import { metaPixelSdkUrl } from './config'

let initialized = false

const getFbq = (): Fbq | null => {
  if (typeof window !== 'undefined' && window.fbq) {
    return window.fbq
  }
  return null
}

const injectSdk = (): void => {
  if (getFbq()) return

  const fbq = (function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
    } else {
      fbq.queue.push(args)
    }
  }) as unknown as Fbq

  fbq.push = fbq as unknown as (...args: unknown[]) => void
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = metaPixelSdkUrl

  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)
}

export const initMetaPixel = (pixelIds: string[]): void => {
  if (initialized) return

  injectSdk()

  pixelIds.forEach((pixelId): void => {
    window.fbq('init', pixelId)
  })

  initialized = true
}

export const trackMetaPixelEvent = (eventName: string, params?: Record<string, unknown>): void => {
  const fbq = getFbq()
  if (!fbq) return

  if (params) {
    fbq('track', eventName, params)
  } else {
    fbq('track', eventName)
  }
}

export const trackMetaPixelSingleEvent = (
  pixelId: string,
  eventName: string,
  params?: Record<string, unknown>,
): void => {
  const fbq = getFbq()
  if (!fbq) return

  if (params) {
    fbq('trackSingle', pixelId, eventName, params)
  } else {
    fbq('trackSingle', pixelId, eventName)
  }
}

export const trackMetaPixelCustomEvent = (eventName: string, params?: Record<string, unknown>): void => {
  const fbq = getFbq()
  if (!fbq) return

  if (params) {
    fbq('trackCustom', eventName, params)
  } else {
    fbq('trackCustom', eventName)
  }
}
